<template>
  <div class="generic-faq-shell">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app-dashboard-generic-faq'
}
</script>

<style scoped>
.generic-faq-shell {
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  width: 100%;
}
</style>
